import { api } from 'utility';
import { getUserInfoBySearchUrl, getFinancialTransferDeligationUrl , getUserInfoBySearchSubscriptionsUrl , getInqueryDeligation} from 'URLs';
export function transfer(data) {
  return api.post(getFinancialTransferDeligationUrl(), data).then((res) => res.data);
}

export function checkContactSybscriptions(params) {
  return api.get(getUserInfoBySearchSubscriptionsUrl(), { params }).then((res) => res.data);
}
export function checkContactDelegation(params) {
  return api.get(getInqueryDeligation(), { params }).then((res) => res.data);
}
export function checkContact(params) {
  return api.get(getUserInfoBySearchUrl(), { params }).then((res) => res.data);
}
export default {
  checkContact,
  transfer,
  checkContactDelegation,
  checkContactSybscriptions
};
